import React, { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import DashboardBanner from "../../shared/DashboardBanner";
import { StatusDashboardData } from "./StatusDashboardData";
import RenderStatusChart from "./RenderStatusChart";
import './StatusDashboard.scss';
import { useSelector, useDispatch } from "react-redux";
import { GET_WEEKLY_STATUS_HEADER } from "../../../redux/constants/constants";
import logo from "../../../assets/vizr_images/report_header.png";
import LoaderComponent from "../../shared/LoaderComponent";

function GovernorDashboard() {
    const changeUser = () => null;
    const loading = false;
    const [ avoidRenderingId, setAvoidRenderingId ] = useState([]);
    const dispatch = useDispatch();
    const avoidRendering = (dashboardData) => {
      setAvoidRenderingId([...avoidRenderingId, dashboardData.id])
    }
    // useEffect(() => {
    //     // dispatch({ type: GET_WEEKLY_STATUS_HEADER });
    // }, []);

    return (
        <div className="status-dashboard-container">
            <DashboardBanner
                project="RISK"
                currentUser="Governor Status Dashboard"
                renderOptions={null}
                changeUser={changeUser}
            ></DashboardBanner>
            {loading ?
                <div className="loader"><LoaderComponent /></div> :
                <div className="main-dashboard-container">
                    <Grid container>
                        {StatusDashboardData &&
                            StatusDashboardData.length > 0 &&
                            StatusDashboardData.map((statusDashboard, index) => {
                                return avoidRenderingId.indexOf(statusDashboard.id) === -1 ?
                                    (
                                        <Grid
                                            key={index}
                                            className={statusDashboard.class}
                                            xs={statusDashboard.size}
                                        >
                                            <RenderStatusChart statusDashboard={statusDashboard} avoidRendering={avoidRendering}/>
                                        </Grid>
                                    ) : null;
                            })}
                    </Grid>
                </div>
            }
        </div>
    )
}

export default React.memo(GovernorDashboard);